import {
  makeStyles,
  createStyles,
  Theme
} from '@material-ui/core/styles'
import { GREY_COLOR, PRIMARY_COLOR } from "~/constants/colors"

const heroImage = `${process.env.GATSBY_IMAGES}expertise/tooth-hero.png`;
const womenSmile = `${process.env.GATSBY_IMAGES}expertise/women-smile.png`;

export default makeStyles((theme: Theme) => createStyles({
  flexColumnBlock: {
    display: 'flex',
    flexDirection: 'column'
  },
  flexRowBlock: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  heroContainer: {
    padding: 32,
    height: 567,
    [theme.breakpoints.down('md')]: {
      padding: '32px 40px',
      height: 402
    },
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      height: 432
    },
    [theme.breakpoints.down('xs')]: {
      padding: 0,
      height: 375
    }
  },
  heroImage: {
    width: '100%',
    height: '100%',
    borderRadius: 4,
    backgroundImage: `url(${heroImage})`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    overflow: 'hidden',
    backgroundSize: 'cover',
    [theme.breakpoints.down('md')]: {
      borderRadius: 0
    }
  },
  mainContainer: {
      padding: 32,
      [theme.breakpoints.down('md')]: {
         padding: '32px 40px'
      },
      [theme.breakpoints.down('xs')]: {
         padding: '32px 16px'
      }
  },
  perfectlyAlignedBlock: {
    alignItems: 'center'
  },
  perfectTitle: {
    color: PRIMARY_COLOR.Primary1,
    width: 650,
    textAlign: 'center',
    marginTop: 24,
    [theme.breakpoints.down(670)]:{
      width: '100%'
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    }
  },
  perfectSubTitle: {
    color: GREY_COLOR.Grey2,
    marginTop: 30,
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      marginTop: 16
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: 28
    }
  },
  perfectText: {
    color: GREY_COLOR.Grey1,
    width: 592,
    textAlign: 'center',
    marginTop: 16,
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    }
  },
  betterOutcomeContainer: {
      marginTop: 132,
      alignItems: 'flex-start',
      padding: '0 80px',
      [theme.breakpoints.down('md')]: {
        padding: '0 4px'
      },
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column-reverse',
        padding: 0
      },
      [theme.breakpoints.down('xs')]: {
        marginTop: 96
      }
  },
  betterOutcomeContainerItems: {
    width: '50%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    }
  },
  betterOutcomeHeader: {
    color: GREY_COLOR.Grey1,
    marginBottom: 16,
    [theme.breakpoints.down('sm')]: {
      marginTop: 32
    }
  },
  betterOutcomeText: {
    color: GREY_COLOR.Grey1,
    display: 'block',
    width: 528,
    marginBottom: 29,
    [theme.breakpoints.down('md')]: {
      width: 456,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    }
  },
  betterOutcomeImage: {
    width: '100%',
    height: 353,
    backgroundImage: `url(${womenSmile})`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    overflow: 'hidden',
    backgroundSize: 'cover',
    borderRadius: 4,
    [theme.breakpoints.down('md')]: {
      height: 304
    },
    [theme.breakpoints.down('sm')]: {
      height: 460
    },
    [theme.breakpoints.down('xs')]: {
      height: 229
    }
  },
  advantagesBlock: {
      marginTop: 138,
      [theme.breakpoints.down('md')]: {
        marginTop: 75
      },
      [theme.breakpoints.down('xs')]: {
        marginTop: 62
      }
  },
  linksBlock: {
    padding: '0 16px 112px',
    width: '100%',
    margin: 0,
    backgroundColor: GREY_COLOR.Grey6,
    [theme.breakpoints.down('md')]: {
      padding: '0 28px 112px'
    },
    [theme.breakpoints.down('xs')]: {
      padding: '0 4px 116px'
    }
  },
  linksTitle: {
    color: '#414448',
    marginBottom: 8
  },
  linksSubTitle: {
    color: GREY_COLOR.Grey1,
    marginBottom: 24
  }

}));
